import { CloseButton, Image, Text } from "@chakra-ui/react";
import React from "react";
import styles from "./toastView.module.css";
import MenuBoard from "../../atoms/icons/menuBoard.svg";

export default function ToastView({ description, handleClose }) {
  return (
    <div className={styles["container-toast"]}>
      <Image cursor={"pointer"} w={"24px"} h={"24px"} src={MenuBoard}></Image>
      <Text
        w={"100%"}
        paddingLeft={"10px"}
        cursor={"pointer"}
        fontFamily={"Poppins, Text-sm/Regular"}
        fontWeight={400}
        fontSize={"14px"}
        lineHeight={"21px"}
        textColor={"#FF0022"}>

        {description}
      </Text>
      <CloseButton color={"#FF0022"} onClick={handleClose} />
    </div>);

}